import React from 'react';
import { CreateUser } from '../..';
import { USER_ROLES } from '../../../constants/constants';

export const HO_CreateUser = (props) => (
  <CreateUser title='Add New User' headText='Provide information for the new User' managedRole={USER_ROLES.HO_EMPLOYEE} {...props} />
);
